import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBCol  } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import Modalarticlefaculty from './Modalarticlefaculty';
import Modalsentedit from './Modalsentedit';
import Modalsuccess from './Modalsuccess';
import { Chart } from "react-google-charts";







export default class adminfacultyproportion extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          articlestapat2:[],
          articlestapat3:[],
          articlestapat4:[],
          articlestapat5:[],
          articlestapat6:[],
            article2:[],

            activeItem: "1",
            admin_faculty:"",
        };
         this.selectarticlefaculty = this.selectarticlefaculty.bind(this);
          this.selectatf = this.selectatf.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
        // this.updateat = this.updateat.bind(this);
      }



      componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlefacultyproportion.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

           Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlefacultyproportion2.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlestapat2: res.data})
           }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat3.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat3: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat4.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat4: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat5.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat5: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat6.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat6: res.data})
          //  }) 

         }, 0);
      }

      selectatf() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }

        setTimeout(() => {
           //ภายใน
          //   Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlesci1: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat2.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat2: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat3.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat3: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat4.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat4: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat5.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat5: res.data})
          //  }) 

          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefacultystapat6.php?faculty='+localStorage.getItem('admin_faculty'))
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //    this.setState({ articlestapat6: res.data})
          //  }) 

         }, 0);
      }


      selectarticlefaculty() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
            this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        }
        setTimeout(() => {
           //ภายใน
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

         }, 0);
      }


    render() {
        return (
            <MDBContainer >
            <div>
             
                <p className="text-right"> (ผู้ดูแลระบบระดับคณะ)</p>
                <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 

                { localStorage.getItem('admin_faculty') == 7 ? <><p className="text-right">มรภ.กพ แม่สอด</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 6 ? <><p className="text-right">คณะพยาบาลศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 5 ? <><p className="text-right">คณะเทคโนโลยีอุตสาหกรรม</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 4 ? <><p className="text-right">คณะวิทยาการจัดการ</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 3 ? <><p className="text-right">คณะมนุษยศาสตร์และสังคมศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 2 ? <><p className="text-right">คณะวิทยาศาสตร์และเทคโนโลยี</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 1 ? <><p className="text-right">คณะครุศาสตร์</p></>:<></>}
               

                <MDBAlert color="success" >
        <h4><MDBIcon icon="address-book" className="green-text pr-3" /> บทความภายใน จำนวน {this.state.articlesci1.length} บทความ</h4>
                </MDBAlert>

                {/* <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" /> */}
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        {/* <th>จัดการ</th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlesci1.map((articlesci1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci1.send_name}  </td>
                        <td>{articlesci1.register_pname}{articlesci1.register_nameth}  {articlesci1.register_lnameth} <br/> {articlesci1.register_phone} </td>
                        <td>{articlesci1.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlesci1.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlesci1.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    {/* <td>   <Modalarticlefaculty  id_send={articlesci1.id_send} namearticla={articlesci1.send_name} selectatf={this.selectatf}/></td> */}
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

               <MDBAlert color="primary" >
                    <h4><MDBIcon icon="shipping-fast"  className="blue-text pr-3"/> บทความภายนอก จำนวน {this.state.articlestapat2.length} บทความ</h4>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        {/* <th>จัดการ</th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlestapat2.map((articlestapat2,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlestapat2.send_name}  </td>
                        <td>{articlestapat2.register_pname}{articlestapat2.register_nameth}  {articlestapat2.register_lnameth} <br/> {articlestapat2.register_phone} </td>
                        <td>{articlestapat2.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlestapat2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlestapat2.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    {/* <td>   <Modalarticlefaculty  id_send={articlesci1.id_send} namearticla={articlesci1.send_name} /></td> */}
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>



           <MDBCol size="6">
              
              <div className={"my-pretty-chart-container"}>
              <Chart
    width={'700px'}
    height={'400px'}
    chartType="PieChart"
    loader={<div>Loading Chart</div>}
    data={[
      ['Task', 'Hours per Day'],
      ['จำนวนบทความ ภายใน', this.state.articlesci1.length],
      ['จำนวนบทความ ภายนอก', this.state.articlestapat2.length],
     
    ]}
    options={{
      title: 'กราฟสรุปจำนวนบทความ',
      // Just add this option
      is3D: true,
    }}
    rootProps={{ 'data-testid': '2' }}
  />
        </div>
              </MDBCol>

              
            </div>
            </MDBContainer>

        )
    }
}
